"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Foldable = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var React = __importStar(require("react"));
var Image_1 = require("../Image");
require("./foldable.css");
var Foldable = function (props) {
    var _a = React.useState({ open: props.open ? 'open' : 'close' }), state = _a[0], setState = _a[1];
    React.useEffect(function () { return setState({ open: props.open ? 'open' : 'close' }); }, [props.open]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "foldable" }, { children: [props.badgeImage ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "image-wrapper" }, { children: (0, jsx_runtime_1.jsx)(Image_1.Image, { src: props.badgeImage }) }))) : null, (0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('foldable-element', "theme-".concat(props.theme), props.horizontalFold ? 'horizontal-fold' : undefined) }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)('header', "header-".concat(state.open)) }, { children: [(0, jsx_runtime_1.jsx)("span", { children: props.label }), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('fold-button', state.open), onClick: function () { return setState({ open: state.open === 'close' ? 'open' : 'close' }); } }, { children: props.openAction }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('wrapper-content', "wrapper-content-".concat(state.open)) }, { children: props.children }))] }))] })));
};
exports.Foldable = Foldable;
//# sourceMappingURL=Foldable.js.map